import type { PODraft, POHelpData } from "@/app/types/purchaseOrders.types";
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";


interface PurchaseOrdersState {
  helperData: POHelpData | null;
  isHelperDataLoaded: boolean;
  isPurchaseOrdersLoaded: boolean;
  draft: PODraft | null;
  isDraftDataLoaded: boolean;
}

const initialState: PurchaseOrdersState = {
  helperData: null,
  isHelperDataLoaded: false,
  isPurchaseOrdersLoaded: false,
  draft: null,
  isDraftDataLoaded: false,
};

const purchaseOrdersSlice = createSlice({
  name: "purchaseOrders",
  initialState,
  reducers: {
    setHelperData: (state, action: PayloadAction<POHelpData>) => {
      state.helperData = action.payload;
      state.isHelperDataLoaded = true;
    },
    clearHelperData: (state) => {
      state.helperData = null;
      state.isHelperDataLoaded = false;
    },
    setPurchaseOrdersLoaded: (state, action: PayloadAction<boolean>) => {
      state.isPurchaseOrdersLoaded = action.payload;
    },
    setPODraft: (state, action: PayloadAction<PODraft>) => {
      state.draft = action.payload;
      state.isDraftDataLoaded = true;
    },
    clearPODraft: (state) => {
      state.draft = null;
      state.isDraftDataLoaded = false;
    },
  },
});

export const { setHelperData, clearHelperData, setPurchaseOrdersLoaded, setPODraft, clearPODraft } =
  purchaseOrdersSlice.actions;

export const selectHelperData = (state: { purchaseOrders: PurchaseOrdersState }) =>
  state.purchaseOrders.helperData;

export const selectIsHelperDataLoaded = (state: { purchaseOrders: PurchaseOrdersState }) =>
  state.purchaseOrders.isHelperDataLoaded;

export const selectIsPurchaseOrdersLoaded = (state: { purchaseOrders: PurchaseOrdersState }) =>
  state.purchaseOrders.isPurchaseOrdersLoaded;

export const selectPODraft = (state: { purchaseOrders: PurchaseOrdersState }) =>
  state.purchaseOrders.draft;

export const selectIsPODraftLoaded = (state: { purchaseOrders: PurchaseOrdersState }) =>
  state.purchaseOrders.isDraftDataLoaded;

export const purchaseOrdersReducer = purchaseOrdersSlice.reducer;
